import React from 'react';
import { CheckIcon } from '@applyft-web/ui-components';
import * as S from './styled';

type CheckboxProps = {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode | string;
  error?: boolean;
  consent?: boolean;
};

export const Checkbox = ({
  id = 'consent-checkbox',
  checked,
  onChange,
  label,
  error = false,
  consent = false,
}: CheckboxProps) => (
  <S.CheckboxWrapper $error={error} $consent={consent}>
    <S.Checkbox
      type="checkbox"
      id={id}
      className="checkbox"
      checked={checked}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
    />
    <CheckIcon />
    {label}
  </S.CheckboxWrapper>
);
